(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cabana-custom-process"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.custom-process__form').forEach((form) => {
    if (form.dataset.cabanaPrefillReady === 'true') return;
    form.dataset.cabanaPrefillReady = 'true';

    const params = new URLSearchParams(window.location.search);
    const product = params.get('product');
    const fabric = params.get('fabric');
    if (!product && !fabric) return;

    const selection = form.querySelector('[data-custom-selection]');
    const productDisplay = form.querySelector('[data-custom-selection-product]');
    const fabricDisplay = form.querySelector('[data-custom-selection-fabric]');
    const productInput = form.querySelector('[data-custom-product-input]');
    const fabricInput = form.querySelector('[data-custom-fabric-input]');
    const projectType = form.querySelector('select[name="contact[project_type]"]');
    const message = form.querySelector('textarea[name="contact[body]"]');

    if (product) {
      productDisplay.textContent = product;
      productInput.value = product;
    }
    if (fabric) {
      fabricDisplay.textContent = fabric;
      fabricInput.value = fabric;
    }
    selection.hidden = false;

    if (projectType) projectType.selectedIndex = 2;
    if (message && !message.value.trim()) {
      const details = [product && `Product: ${product}`, fabric && `Fabric: ${fabric}`].filter(Boolean);
      message.value = `${details.join('\n')}\n\nProject details: `;
    }
    document.querySelector('#custom-inquiry')?.scrollIntoView({ block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cabana-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  const editorialHeroVideos = document.querySelectorAll('.cabana-editorial-hero__video');

  editorialHeroVideos.forEach((video) => {
    const button = video.closest('.cabana-editorial-hero').querySelector('.cabana-editorial-hero__motion');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const syncLabel = () => {
      const label = video.paused ? button.dataset.playLabel : button.dataset.pauseLabel;
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
      button.dataset.paused = String(video.paused);
    };
    video.muted = true;
    button.hidden = false;
    button.addEventListener('click', () => {
      if (video.paused) video.play().catch(syncLabel);
      else video.pause();
    });
    video.addEventListener('play', syncLabel);
    video.addEventListener('pause', syncLabel);
    reducedMotion.addEventListener('change', (event) => { if (event.matches) video.pause(); });
    if (!reducedMotion.matches) video.play().catch(syncLabel);
    syncLabel();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cabana-paper-to-reality"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-paper-reality]').forEach((stage) => {
    const control = stage.querySelector('.paper-reality__control');
    const update = () => {
      stage.style.setProperty('--position', `${control.value}%`);
      if (Number(control.value) > 72) stage.setAttribute('data-revealed', '');
      else stage.removeAttribute('data-revealed');
    };
    control.addEventListener('input', update);
    update();
  });

  } catch(e) { console.error(e); }
})();
})();
